/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists} from '../runtime';
import {Job, JobFromJSON, JobToJSON,} from './Job';

/**
 *
 * @export
 * @interface JobIReadOnlyCollectionApiResult
 */
export interface JobIReadOnlyCollectionApiResult {
    /**
     *
     * @type {boolean}
     * @memberof JobIReadOnlyCollectionApiResult
     */
    success?: boolean;
    /**
     *
     * @type {Array<Job>}
     * @memberof JobIReadOnlyCollectionApiResult
     */
    content?: Array<Job> | null;
    /**
     *
     * @type {string}
     * @memberof JobIReadOnlyCollectionApiResult
     */
    message?: string | null;
}

export function JobIReadOnlyCollectionApiResultFromJSON(json: any): JobIReadOnlyCollectionApiResult {
    return JobIReadOnlyCollectionApiResultFromJSONTyped(json, false);
}

export function JobIReadOnlyCollectionApiResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobIReadOnlyCollectionApiResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'success': !exists(json, 'success') ? undefined : json['success'],
        'content': !exists(json, 'content') ? undefined : (json['content'] === null ? null : (json['content'] as Array<any>).map(JobFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function JobIReadOnlyCollectionApiResultToJSON(value?: JobIReadOnlyCollectionApiResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'success': value.success,
        'content': value.content === undefined ? undefined : (value.content === null ? null : (value.content as Array<any>).map(JobToJSON)),
        'message': value.message,
    };
}

